import { AppMsgCode, Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    [AppMsgCode.SomethingWentWrong]:
      'Something went wrong. Please refresh or try again later.',
    [AppMsgCode.AuthenticationFailed]: 'Authentication failed',
    [AppMsgCode.NoCredentialsProvided]: 'No credentials provided',
    [AppMsgCode.TokenExpired]: 'Your session expired. You need to log in again.',
    [AppMsgCode.NoSuchUser]: 'No such user',
    [AppMsgCode.NoSuchQuestion]: 'No such question',
    [AppMsgCode.EmailNotConfirmed]: 'Email not confirmed',
    [AppMsgCode.NotFullAccount]: 'Not a full account',
    [AppMsgCode.IllegalAction]: 'Illegal action performed',
    [AppMsgCode.ActivationLinkSent]:
      'The verification link has been sent to you. Please check your mailbox.',
    [AppMsgCode.DeactivationLinkSent]:
      'The deactivation link has been sent to you. Please check your mailbox.',
    [AppMsgCode.RecoveryLinkSent]:
      'The password recovery link has been sent to you. Please check your mailbox.',
    [AppMsgCode.PasswordUpdated]: 'Password updated',
    [AppMsgCode.PasswordRecovered]:
      'Your password has been reset and sent to your mailbox. Please log in and update it as soon as possible.',
    [AppMsgCode.UserDetailsUpdated]: 'User details updated',
    [AppMsgCode.EmailAlreadyConfirmed]: 'Email already confirmed',
    [AppMsgCode.EmailConfirmed]:
      'Your email address has been confirmed. You can close this window.',
    [AppMsgCode.AccountRemoved]:
      'You account has been removed. You can close this window.',
    [AppMsgCode.PaymentAlreadyMade]: 'Payment already made',
    [AppMsgCode.CouldNotGetData]: 'Could not get data',
    [AppMsgCode.QuestionAlreadyFollowed]: 'Question already followed',
    [AppMsgCode.QuestionAlreadyUnfollowed]: 'Question already unfollowed',
    [AppMsgCode.QuestionDeleted]: 'Question deleted',
    [AppMsgCode.QuestionMustHaveBeenDeleted]: 'Question must have been deleted',
    [AppMsgCode.QuestionCreated]: 'Question created',
    [AppMsgCode.QuestionReported]: 'Question reported',
    [AppMsgCode.QuestionAlreadyReported]: 'Question already reported',
    [AppMsgCode.QuestionFollowed]: 'Question followed',
    [AppMsgCode.QuestionUnfollowed]: 'Question unfollowed',
    [AppMsgCode.AvatarUpdated]: 'Uploaded !',
  },
}
